import { createStyles } from "antd-style";

export const useNotificationsStyles = createStyles(({ token, css }: any) => ({
  root: css`
    width: 100%;
  `,
  nav: css`
    min-width: 80px;
    flex-shrink: 0;
    background: ${token.ColorFigmaNeutralGrayscaleGray30};
  `,
  navActions: css`
    background: ${token.ColorFigmaNeutralWhiteWhite100};
    padding: 4px;

    button {
      width: 24px !important;
      height: 24px !important;
      border-radius: 2px !important;
      background: ${token.ColorFigmaNeutralGrayscaleGray30} !important;
    }
  `,
  navContent: css`
    padding: 4px 8px;
  `,
  tag: css`
    padding: 2px !important;
    color: ${token.ColorFigmaNeutralGrayscaleGray90} !important;
    padding: 2px !important;
    min-height: 0 !important;
    min-width: 0 !important;
    height: auto;
    display: flex;
    height: 24px;
    align-items: center;
    justify-content: center;
    margin: 0;
  `,
}));
